import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useFeedSourceFeedStore = defineSmartFeedPiniaStore(
  "feed-source-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
    }),
    getters: {
      feedUrl() {
        return `/feeds/source/${this.filters[0].value}`;
      },
    },
  },
);
